module.exports = __webpack_public_path__ + "static/media/virgin-radio.556b13de.png";